import { useProjectQueryContext } from 'modules/billing/contexts/ProjectQueryContext';
import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { LinkContent } from 'ui/pageHeader/types';
import { ColumnData } from 'ui/tableHeader';
import { Row } from '../components/SimpleIndexPage/types';
import {
  createBreadcrumb,
  createProjectBreakdownColumns,
  createProjectBreakdownRows,
} from '../utils/projectBreakdown';

export type UseProjectUsageResult = {
  breadcrumb: LinkContent;
  columns: ColumnData[];
  isLoading: boolean;
  rows: Row[];
};

export const useProjectUsage = (metricNames: string[]): UseProjectUsageResult => {
  const { search } = useLocation();
  const { isLoading: isLoadingOrg, orgMetricsByName } = useQueryContext();
  const {
    isLoading: isLoadingProject,
    projects,
    projectUsageMetrics: { ByOrgProject = {} },
  } = useProjectQueryContext();

  /**
   * Ensures the project breakdown page is scrolled to the top
   * If the index page was scrolled down, it was keeping scroll position when viewing breakdown page
   * https://v5.reactrouter.com/web/guides/scroll-restoration/scroll-to-top
   *
   */
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  const isLoading = isLoadingOrg || isLoadingProject;
  const breadcrumb = createBreadcrumb(search);
  const columns = createProjectBreakdownColumns(metricNames);
  const rows = createProjectBreakdownRows({
    metricNames,
    orgMetricsByName,
    projects,
    metrics: ByOrgProject,
  });

  return { breadcrumb, columns, isLoading, rows };
};
